import React from 'react';
import { useCapabilities } from '../../Shared/capabilities';
import { useHeaderActions } from './HeaderContext';
import HeaderExtensionsList from './HeaderExtensionsList';
import styles from './LargeScreenHeaderNav.module.scss';

const LargeScreenHeaderNav = () => {
  const capabilities = useCapabilities();
  const { openNavigationMenu, openLoginWizard } = useHeaderActions();

  return (
    <nav className={styles.nav}>
      <HeaderExtensionsList />

      {capabilities.showAdminCapabilities && (
        <button
          className={styles.navLink}
          onClick={() => openNavigationMenu('admin')}
          type="button"
        >
          Admin
        </button>
      )}

      <button
        className={styles.navLink}
        onClick={() => openNavigationMenu('community')}
        type="button"
      >
        Community
      </button>

      {capabilities.showAccountNavigation && (
        <button
          className={styles.navLink}
          onClick={() => openNavigationMenu('your-account')}
          type="button"
        >
          Your Account
        </button>
      )}

      {capabilities.showLoginNavigation && (
        <button
          className={styles.navLink}
          onClick={openLoginWizard}
          type="button"
        >
          Log In
        </button>
      )}
    </nav>
  );
};

export default LargeScreenHeaderNav;
